import React, { Component } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import logo from "./logo.svg";
import "./assets/fonts/fonts.css";
import "./App.scss";

import Main from "./pages/Main";

function App() {
  const models = {
    718: { image: "718.png", modelType: "718" },
    911: { image: "911.png", modelType: "911" },
    Taycan: { image: "Taycan.png", modelType: "taycan" },
    Panamera: { image: "Panamera.png", modelType: "panamera" },
    Macan: { image: "Macan.png", modelType: "macan" },
    Cayenne: { image: "Cayenne.png", modelType: "cayenne" },
  };
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Main models={models} />} />
        <Route path="/:komnr" element={<Main models={models} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
